
export default{
    //保存用户信息
    saveInfo({commit}, {userName,roleId,roleName,name,roleType,realName,mobile,email,customerType, parallelUserName}) {
        commit('setUserName', userName);
        commit('setName', name);
        commit('setRoleId', roleId); 
        commit('setRoleName', roleName);
        commit('setRoleType', roleType);
        commit('setParallelUserName', parallelUserName);
        
        commit('setRealName', realName);
        commit('setMobile', mobile);
        commit('setEmail', email);
        commit('setCustomerType', customerType);
        

    },
    //保存面包屑
    saveCrumbs({commit},crumbsArr){
        commit('setCrumbsArr', crumbsArr);
    },
    //储存跳转路由
    saveJumpMenu({commit},JumpMenu){
        commit('setJumpMenu', JumpMenu);
    },
    //储存菜单列表
    saveMenu({commit},menu){
        commit('setMenu', menu);
    },
    //储存菜单ur;
    saveLogUrl({commit},logUrl){
        commit('setLogUrl', logUrl);
    },
    //获取菜单的width;
    saveMenuWidth({commit},menuWidth){
        commit('setMenuWidth', menuWidth);
    },
    //获取页面的按钮;
    saveButtons({commit},buttons){
        commit('setButtons', buttons);
    },
    //获取tokens;
    saveTokens({commit},tokens){
        commit('setTokens', tokens);
    },
    //获取购物详情;
    saveShopping({commit},shopping){
        commit('setShopping', shopping);
    },
    //获取子用户;
    saveSubUser({commit},subUser){
        commit('setSubUser', subUser);
    },
    //获取卡续费条件;
    saveCardRenewal({commit},cardRenewal){
        commit('setCardRenewal',cardRenewal);
    },
    //获取销售订单信息;
    saveOrderInfo({commit},orderInfo){
        commit('setOrderInfo',orderInfo);
    },
    //单池卡，语音卡通过ICCID 跳转页面使用
    saveCardIccid({commit},cardIccid){
        commit('setCardIccid',cardIccid);
    },
    //获取用户池信息;
    saveUserPoolCard({commit},shopping){
        commit('setUserPoolCard', shopping);
    },

    //Tabs视图
    saveVisitedViews({commit},visitedViews){
      commit('setVisitedViews', visitedViews);
    },
    //缓存
    saveCachedViews({commit},cachedViews){
      commit('setCachedViews', cachedViews);
    },
    //路由表
    saveRouteList({commit},routeList){
        commit('setRouteList', routeList);
    },
    //合同编号
    saveContractNumber({commit},contractNumber){
        commit('setContractNumber', contractNumber);
    },
    saveJumpParams({commit},JumpParams){
        commit('setJumpParams', JumpParams);
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js